<template>
	<div>home</div>
</template>
 
<script>
export default {
	data: function () {
		return {


		};
	},
	created() {
		this.$router.push('/jobs/ALL')
	},
}
</script> 
 
